import { Box, Typography } from "@mui/material"
import { PropsWithChildren } from "react"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    box: {
        display: "flex",
        borderRadius: "0.25rem",
        padding: "0 0.375rem",
        color: theme.palette.common.white,
        backgroundColor: theme.palette.tailwind.green[500],
    },
    container: {
        width: "3.125rem",
        height: "3.125rem",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        wordWrap: "break-word",
        fontSize: "0.75rem",
        fontWeight: 500,
        borderRadius: "50%",
        textAlign: "center",
        fontFamily: theme.typography.fontFamily,
        backgroundColor: theme.palette.tailwind.slate[900],
        color: theme.palette.common.white,
    },
}))

type TagProps = Readonly<{
    children: string | JSX.Element | number | string[]
}>

export const Tag = ({ children }: TagProps) => {
    const { classes } = useStyles()

    return (
        <Box className={classes.box}>
            <Typography fontWeight={500} variant="caption">
                {children}
            </Typography>
        </Box>
    )
}

export const TagRounded = ({ children }: PropsWithChildren) => {
    const { classes } = useStyles()

    return <Box className={classes.container}>{children}</Box>
}
